import { render, staticRenderFns } from "./HotelShortRoomCreate.vue?vue&type=template&id=3138771c&scoped=true&"
import script from "./HotelShortRoomCreate.vue?vue&type=script&lang=js&"
export * from "./HotelShortRoomCreate.vue?vue&type=script&lang=js&"
import style0 from "./HotelShortRoomCreate.vue?vue&type=style&index=0&id=3138771c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3138771c",
  null
  
)

export default component.exports